// page-document-request.jsx — 資料請求 (CF7 駆動)

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  function DocumentRequestPage() {
    const data = window.HB_DOCREQUEST || { formHtml:'<p>フォームの準備中です。</p>' };
    const formHostRef = React.useRef( null );

    React.useEffect( () => {
      if ( ! formHostRef.current ) return;
      const formEl = formHostRef.current.querySelector( 'form.wpcf7-form' );
      if ( formEl && window.wpcf7 && typeof window.wpcf7.init === 'function' ) {
        try { window.wpcf7.init( formEl ); } catch ( e ) {}
      }
    }, [] );

    return (
      <HBLayout>
        <HBSubHero
          crumb={`Other / 資料請求`}
          en="Document request"
          jp={<span><span style={{color:hbcp.blue}}>サービス資料</span>を、<br/>ご請求ください。</span>}
          tag={'Plans, pricing, case studies — get the PDFs.'}
          lead={'Hatena DX / Content / BI / 税理士法人 / 経営コンサルティングなど、各サービスの導入の進め方・料金感・事例をまとめた資料を順次公開しています。フォームからご請求ください。'}
        />

        <section style={{padding:'72px 32px 96px', background:hbcp.white}}>
          <div style={{maxWidth:1080, margin:'0 auto', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:64, alignItems:'flex-start'}}>
            <div ref={formHostRef} className="hb-cf7-host"
              dangerouslySetInnerHTML={{ __html: data.formHtml }}/>

            <aside>
              <div style={{padding:'32px', background:hbcp.paper, border:`1px solid ${hbcp.line}`, marginBottom:24}}>
                <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, marginBottom:14}}>● ABOUT</div>
                <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, margin:'0 0 14px'}}>個別相談も承ります</h3>
                <p style={{fontSize:13.5, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 18px'}}>
                  「具体的なケース別の見積もり」「業界別のテンプレート」など、ご希望をお伝えください。<br/>
                  個別に作成・お渡しします。
                </p>
                <a href={`${HB_BASE}/contact`} style={{display:'inline-flex', alignItems:'center', gap:8, fontFamily:fontENSans, fontSize:11, fontWeight:600, letterSpacing:'.16em', color:hbcp.blue, textDecoration:'none', borderBottom:`1px solid ${hbcp.blue}`, paddingBottom:4}}>
                  個別相談する <span style={{fontFamily:fontEN}}>→</span>
                </a>
              </div>

              <div style={{padding:'32px', background:'#fff', border:`1px solid ${hbcp.line}`}}>
                <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, marginBottom:14}}>● BY MAIL / PHONE</div>
                <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, margin:'0 0 14px'}}>メール・お電話でも</h3>
                <div style={{fontFamily:fontMono, fontSize:13, color:hbcp.inkSoft, lineHeight:2}}>
                  MAIL  info@hatenabase.com<br/>
                  TEL   03-4500-2647<br/>
                  受付  平日 9:00 - 18:00
                </div>
              </div>
            </aside>
          </div>
        </section>

        {/* CF7 を Variant D の白×青に揃える共通スタイル */}
        <style>{`
          .hb-cf7-host .wpcf7-form p { margin: 0 0 18px; }
          .hb-cf7-host label { display:grid; gap:6px; font-family:"Zen Kaku Gothic New", sans-serif; font-size:13px; font-weight:600; color:${hbcp.ink}; }
          .hb-cf7-host input[type="text"],
          .hb-cf7-host input[type="email"],
          .hb-cf7-host input[type="tel"],
          .hb-cf7-host input[type="url"],
          .hb-cf7-host textarea,
          .hb-cf7-host select {
            width:100%; padding:12px 14px; font-size:14px;
            font-family:"Zen Kaku Gothic New", sans-serif; color:${hbcp.ink};
            background:#fff; border:1px solid ${hbcp.line}; outline:none;
            border-radius:0; box-sizing:border-box;
          }
          .hb-cf7-host textarea { resize:vertical; line-height:1.7; }
          .hb-cf7-host input[type="submit"] {
            padding:16px 36px; background:${hbcp.blue}; color:#fff;
            border:none; cursor:pointer; font-family:"Zen Kaku Gothic New", sans-serif;
            font-size:15px; font-weight:700; letter-spacing:.04em; border-radius:0;
          }
          .hb-cf7-host input[type="submit"]:hover { opacity:.92; }
          .hb-cf7-host .wpcf7-list-item { display:inline-block; margin: 0 18px 8px 0; }
          .hb-cf7-host .wpcf7-acceptance label { display:inline-flex; gap:8px; font-weight:500; }
          .hb-cf7-host .wpcf7-not-valid-tip { color:${hbcp.blue}; font-size:12px; margin-top:6px; }
          .hb-cf7-host .wpcf7-response-output { margin-top:24px; padding:14px 18px; border-left:3px solid ${hbcp.blue}; background:${hbcp.blueGhost}; font-size:13px; }
          .hb-cf7-host span.required, .hb-cf7-host span.wpcf7-required {
            display:inline-block; margin-left:8px; padding:2px 6px;
            font-size:9.5px; letter-spacing:.16em; font-weight:600;
            background:${hbcp.blue}; color:#fff; vertical-align:middle;
          }
        `}</style>
      </HBLayout>
    );
  }

  Object.assign(window, { DocumentRequestPage });
})();
